import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getOrganizationLogo } from '../utils/api_service/organization';
import { setCompanyLogo, setCompanyName } from '../utils/redux_store/features/logo_reducer';
import { applyBrandTheme, initBrandTheme } from '../utils/theme/brandTheme';

export const useLoadLogo = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Immediately apply existing theme from localStorage/fallback
    initBrandTheme();

    const load = async () => {
      try {
        const response = await getOrganizationLogo();
        if (response.ok) {
          const res = await response.json();

          // Save to localStorage
          localStorage.setItem('companyLogo', res.companyLogo || '');
          localStorage.setItem('companyName', res.companyName || '');
          const primary = res.primaryColor || res.brandColor;
          const secondary = res.secondaryColor;
          if (primary || secondary) {
            applyBrandTheme({ primaryColor: primary, secondaryColor: secondary });
          }

          dispatch(setCompanyLogo(res.companyLogo));
          dispatch(setCompanyName(res.companyName));
        }
      } catch (e) {
        console.error(e);
      }
    };
    load();
  }, [dispatch]);
};

